<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">


        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">姓名</div>
            <el-input v-model="edit_name" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">身份证号</div>
            <el-input v-model="edit_idCard" placeholder="请输入身份证号"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">机构</div>
            <el-select v-model="institutionCode" placeholder="请选择机构" style="width: 100%">
              <el-option
                  v-for="item in arr_ins"
                  :key="item.institutionCode"
                  :label="item.userName"
                  :value="item.institutionCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">状态</div>
            <el-select v-model="edit_status" placeholder="请选择状态" style="width:100%">
              <el-option
                  v-for="item in statusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>



      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: ['arr_ins'],
  data() {
    return {

      loading: false,

      edit_name:'',
      edit_idCard:'',
      institutionCode:'',

      statusArr: [{
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '禁用'
      }],
      edit_status: -1,

      nurseAideCode:'',


    }
  },
  methods: {
    init(row){

      this.edit_name = row.name;
      this.edit_idCard = row.idCard;
      this.edit_status = row.status;
      this.nurseAideCode = row.nurseAideCode;
      this.institutionCode = row.institutionCode;

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.edit_name === ''){
        this.$message("输入名称");
        return;
      }
      if(this.edit_idCard === ''){
        this.$message("输入身份证号");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'NurseAide/EditByGov',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,

          name: this.edit_name,
          idCard:this.edit_idCard,
          status:this.edit_status,
          nurseAideCode:this.nurseAideCode,

        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },





  }
}
</script>

